export const ChickenPestoParmImage = require('./chicken-pesto-parm.webp');
export const ClassicChickenCaesarImage = require('./classic-chicken-caesar.webp');
export const HarvestBowlImage = require('./harvest-bowl.webp');
